export const USUARIO_SUPER_ADMIN = 1;
export const USUARIO_ENCUESTADOR = 3;
export const RAITING_NUMBERS = [1,2,3,4,5];

export const API_URL = import.meta.env.VITE_API_URL;
export const SSO_API_URL = import.meta.env.VITE_SSO_API_URL;
export const SSO_SITE_URL = import.meta.env.VITE_SSO_SITE_URL;
export const SSO_ORIGIN = import.meta.env.VITE_SSO_ORIGIN;
export const SESION = import.meta.env.VITE_CONTADOR_REFRESH;

export const ESTATUS_EVALUACION = {
    REGISTRADA: 1,
    LLENADO_PARCIAL: 2,
    COMPLETADA: 3
}